import { render } from "./AssignClaim.vue?vue&type=template&id=7b3b6d2e"
import script from "./AssignClaim.vue?vue&type=script&lang=js"
export * from "./AssignClaim.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__